/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable class-methods-use-this */

import './vendor';
import './helpers';
import './share';
import './analytics';

import {ieFix} from './vendor//ie-fix';
import {iosVhFix} from './vendor//ios-vh-fix';
import './router';

ieFix();
iosVhFix();

import './components/test';
